<!--
 * @Description: 商品统计
 * @Author: yuxin
 * @Date: 2025-06-26 15:27:58
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-07-04 10:28:02
 * @FilePath: \mgr_web\src\views\contentCenter\newMall\goodsStatistics\index.vue
-->

<template>
  <div class="goodsStatistics-container">
    <header>
      <el-input
        placeholder="商品名称"
        suffix-icon="el-icon-search"
        size="mini"
        @blur="searchFn"
        @clear="searchFn"
        v-model="formData.name"
        clearable
        style="width: 180px; margin-right: 10px"
      >
      </el-input>
      <el-button-group>
        <el-button size="mini">
          发送时间
        </el-button>
        <el-date-picker
          v-model="formData.searchSelectTime"
          size="mini"
          type="daterange"
          value-format="yyyy-MM-dd "
          range-separator="~"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          @change="timeChange"
          :clearable="false"
          :editable="false"
          style="width: 240px; margin-right: 10px"
          :default-time="['00:00:00', '23:59:59']"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-button-group>
      <!-- <el-select
        v-model="formData.type"
        placeholder="请选择"
        size="mini"
        @change="typeChange"
      >
        <el-option
          v-for="item in activityOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select> -->
    </header>
    <main>
      <el-table
        ref="tableData"
        :data="tableData"
        style="width: 100%"
        height="calc(100vh - 290px)"
        @sort-change="sortChange"
        :default-sort="{ prop: 'sendTotal', order: 'descending' }"
      >
        <el-table-column prop="name" label="商品名称" width="180">
        </el-table-column>
        <el-table-column
          prop="shareNumber"
          label="发送次数"
          sortable="custom"
          width="180"
          :sort-method="sortMethod"
        >
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="shareOpenNumber"
          label="点击次数"
          :sort-method="sortMethod"
        >
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="openRate"
          label="打开率"
          :sort-method="sortMethod"
        >
          <!-- <template slot-scope="scope">
            {{ scope.row.clickRate }}%
          </template> -->
        </el-table-column>
        <el-table-column
          prop="shelvesOrderNumber"
          label="商品成交量"
          :sort-method="sortMethod"
        >
        </el-table-column>
        <el-table-column
          prop="orderRate"
          label="商品成交率"
          :sort-method="sortMethod"
        >
          <!-- <template slot-scope="scope">
            {{ scope.row.salesRate }}
          </template>-->
        </el-table-column>
      </el-table>
    </main>
    <footer>
      <Pagination
        v-bind:childMsg="pageparm"
        :pageSizes="pageSizes"
        @callBack="callBack"
      ></Pagination>
    </footer>
  </div>
</template>
<script>
import dayjs from "dayjs";
import { getProductDetailApi } from "@/api/contentCenter/Statistics";
/** 检查新旧商城 0： 旧商城 1： 新商城 默认新商城 1 */
import { checkMallSysApi } from "@/api/contentCenter/Statistics";
export default {
  name: "activityStatistics",
  data() {
    return {
      /** 表单数据 */
      formData: {
        /** 条件筛选名称 */
        name: "",

        /** 开始时间 */
        /** 转为时间戳 */
        sendStartTime: dayjs(
          dayjs()
            .subtract(30, "days")
            .format("YYYY-MM-DD 00:00:00")
        ).valueOf(), //开始时间,
        /** 结束时间 */
        /** 转为时间戳 */
        sendEndTime: dayjs(
          dayjs()
            .subtract(1, "days")
            .format("YYYY-MM-DD 23:59:59")
        ).valueOf(), //结束时间,
        /** 前端定义，用于存储时间 */
        searchSelectTime: [
          dayjs()
            .subtract(30, "days")
            .format("YYYY-MM-DD 00:00:00"),
          dayjs()
            .subtract(1, "days")
            .format("YYYY-MM-DD 23:59:59"),
        ],
        /** 活动类型 0:限时特惠 1:砍价 2:抽奖 3:拼团 6.领券活动 全部活动时不传 */
        type: "",
        /** 排序字段 */
        sort: "",
        /** 是否升序 */
        asc: false,
        /** 当前页码 */
        page: 1,
        /** 每页条数 */
        size: 10,
      },
      /** 禁用今天和未来日期的逻辑 */
      pickerOptions: {
        disabledDate(time) {
          /** 获取今天0点的时间戳（去除时间部分） */
          const today = new Date();
          today.setHours(0, 0, 0, 0);

          /** 禁用今天及未来日期（time.getTime() >= today.getTime()） */
          return time.getTime() >= today.getTime();
        },
      },
      /** 筛选的活动集合 */
      //   activityOptions: [
      //     { label: "全部活动", value: "" },
      //     { label: "拼团活动", value: 3 },
      //     { label: "砍价活动", value: 1 },
      //     { label: "限时特惠", value: 0 },
      //     { label: "抽奖活动", value: 2 },
      //   ],

      /** 表格数据 */
      tableData: [],

      /** 分页参数 */
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },

      /** 分页选择参数 */
      pageSizes: [10, 20, 50, 100, 200, 500],
      /** 新旧商城标识  0： 旧商城 1： 新商城 默认新商城 1*/
      currentMallType: 1,
    };
  },
  methods: {
    /** 获取列表数据 */
    async getDataList() {
      const res = await getProductDetailApi(
        this.formData,
        localStorage.getItem("Authorization")
      );
      if (res && res.error.code == 200 && res.data) {
        console.log("res++++", res);
        this.tableData = res.data.records;
        this.pageparm.total = res.data.total ? Number(res.data.total) : 0;
      }
    },

    /**  分页回调 */
    callBack(parm) {
      console.log("分页器XXXX", parm);
      this.formData.page = parm.currentPage;
      this.formData.size = parm.pageSize;
      this.getDataList();
    },

    /** 时间变动触发 */
    timeChange(val) {
      if (val) {
        /** 转为时间戳 */
        this.formData.sendStartTime = dayjs(
          dayjs(val[0]).format("YYYY-MM-DD 00:00:00")
        ).valueOf();
        this.formData.sendEndTime = dayjs(
          dayjs(val[1]).format("YYYY-MM-DD 23:59:59")
        ).valueOf();
      }
      this.getDataList();
    },

    /** 排序变化 */
    sortChange(column, prop, order) {
      console.log("column", column);
      if (!column.order) {
        this.formData.sort = "";
        this.formData.asc = false;
      } else {
        this.formData.sort = column.prop;
        this.formData.asc = column.order === "ascending";
      }
      console.log("this.formData", this.formData);
      this.getDataList();
      //   if (val.order === "ascending") {
      //     this.formData.sortRule = "asc";
      //   } else if (val.order === "descending") {
      //     this.formData.sortRule = "desc";
      //   }
      //   this.formData.sortField = val.prop;
      //   this.getDataList();
      //   console.log(
      //     "排序变化",
      //     this.formData,
      //     dayjs()
      //       .subtract(29, "days")
      //       .format("YYYY-MM-DD hh:mm:ss")
      //   );
    },

    /** 搜索触发 */
    searchFn() {
      this.getDataList();
    },

    /** 类型变触发 */
    typeChange() {
      this.getDataList();
    },

    sortMethod() {},
    /** 获取新、旧商城标识 */
  async  getNewOrOldMallFlag(corpId) {
   const res = await   checkMallSysApi(corpId, localStorage.getItem("Authorization"))
    if (res && res.error.code == 200) {
            this.currentMallType = res.data == null ? 1 : res.data;
          }
  //  .then(
  //       (res) => {
  //         console.log("youmeiyoujinlai", res);
  //         if (res && res.error.code == 200) {
  //           this.currentMallType = res.data == null ? 1 : res.data;
  //         }
  //         console.log("ddddd", this.currentMallType);
  //       }
  //     );
    },

    /** 合计 */
    // getSummaries(param) {
    //   const { columns, data } = param;
    //   const sums = [];
    //   columns.forEach((column, index) => {
    //     if (index === 0) {
    //       sums[index] = "合计";
    //       return;
    //     }
    //     const values = data.map((item) => item[column.property]);
    //     if (values.length > 0 && index !== 5 && index !== 3) {
    //       sums[index] = values.reduce((prev, curr) => {
    //         const value = Number(curr);
    //         if (!isNaN(value)) {
    //           return prev + curr;
    //         } else {
    //           return prev;
    //         }
    //       }, 0);
    //       sums[index];
    //     } else if (index == 3) {
    //       console.log("XXXXXXXXXX打开率", sums);
    //       sums[index] = `${((sums[2] / sums[1]) * 100 >= 100
    //         ? 100
    //         : (sums[2] / sums[1]) * 100
    //       ).toFixed(2)}%`;
    //     } else if (index == 5) {
    //       console.log("XXXXXXXXXX商品成交率", sums[3], sums[1]);

    //       sums[index] = `${((sums[4] / sums[1]) * 100 >= 100
    //         ? 100
    //         : (sums[4] / sums[1]) * 100
    //       ).toFixed(2)}%`;
    //     }
    //   });
    //   // if (index === 5) {
    //   //   sums[index] = `${(sums[4] / sums[3]) * 100}%`;
    //   // }
    //   console.log("总计XXXXXXXX", data, columns, sums);
    //   return sums;
    // },
  },

  /** 生命周期 */
  async created() {
    /** 获取corpid */
    let enterpriseData = JSON.parse(
      window.localStorage.getItem("enterpriseData")
    );

    /** 获取新旧商城标识 */
    await this.getNewOrOldMallFlag(enterpriseData.corpid);
    if (this.currentMallType == 1) {
      /** 获取列表数据 */
      this.getDataList();
    }
  },
};
</script>

<style scoped lang="scss">
.goodsStatistics-container {
  /deep/.el-table {
    overflow: visible !important;
    .has-gutter {
      font-weight: 700;
    }
  }
}
</style>
